"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";
import { RadioSelect } from "@/components/radio-select";
import { cn } from "@/lib/utils";
import { sortingData } from "../data/sorting";

type DietsListSortFilterProps = {
  paramName?: string;
  className?: string;
  type?: "diet" | "catering";
};

export const DietsListSortFilter = ({
  paramName = "sortOption",
  className,
  type = "diet",
}: DietsListSortFilterProps) => {
  const t = useTranslations(type === "diet" ? "diets" : "caterings");

  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const handleChange = (search: string) => {
    const params = new URLSearchParams(searchParams);
    if (search && search !== "default") {
      params.set(paramName, search);
    } else {
      params.delete(paramName);
    }
    params.set("page", "1");
    replace(`${pathname}?${params.toString()}`);
  };

  return (
    <RadioSelect
      className={cn("w-full max-w-72", className)}
      label={t("sort_by")}
      onValueChange={handleChange}
      options={sortingData.map((item) => ({
        label: t(`filters.sort.${item.label}`),
        value: item.value,
      }))}
      placeholder={t("filters.sort.default")}
      value={searchParams.get(paramName)?.toString() ?? "default"}
    />
  );
};
